import { useLocation, useNavigate } from 'react-router';
import { LocationStateBack } from '../models/router';


/**
 * @deprecated use {@link useNavigation} instead
 * @param defaultPath
 */
export const useBack = (defaultPath?: string | null) => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const queryBackTo = searchParams.get('backTo');

  const stateBack = (location.state as LocationStateBack)?.back;
  const backTo = queryBackTo || stateBack || defaultPath;

  const goBack = () => {
    backTo ? navigate(backTo) : window.history.back();
  };

  return { backTo, goBack, navigate };
};
